import React from 'react';
import Modal from '../../component/Inc/Modal';
import LineChart from '../../component/Inc/LineChart';
function PopEvaluationReport(props) {
  const {open, close} = props;
  const lineChartWidth = '100%';
  const lineChartHeight = '160px';
  const lineChartlabels = ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'];
  //line chart data
  const lineChartData = {
    lineChartlabels,
    datasets: [
      {
        label: ' 모의고사 등급',
        data: [1, 5, 9, 8, 1, 4, 5, 6, 3, 3, 10, 4],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#3780ff'
      },
      {
        label: '내신등급',
        data: [1, 4, 5, 2, 5, 9, 7, 6, 6, 1, 8, 5],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#fc8019'
      }
    ]
  };
  return (
    <Modal open={open} close={close} type="com_input pop_evaluation_report">
      <h2 className="pop_tit">수업 평가 보고서</h2>
      <div className="content_container">
        <div className="content_wrap">
          <section className="content_box scroll">
            <div className="com_info">
              <p className="name">홍길동104</p>
              <span className="dot"></span>
              <p className="date">2023.05.20 11:30</p>
            </div>

            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="tit">학생명</span>
                  <span className="cont">
                    <button className="name btn_link">홍길동103 </button>
                    <span> (고3ㆍ경기고등학교ㆍ본사) </span>
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">수업 방법</span>
                  <span className="cont">대면</span>
                </div>
                <div className="info">
                  <span className="tit">수업 과목</span>
                  <span className="cont">과탐</span>
                </div>
                <div className="info">
                  <span className="tit">기수 / 타임</span>
                  <span className="cont">2기 / 2T</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">수업 회차</span>
                  <span className="cont">(1회차 2023, 05, 10ㅣ12:30), (1회차 2023, 05, 10ㅣ12:30), (1회차 2023, 05, 10ㅣ12:30), (1회차 2023, 05, 10ㅣ12:30)</span>
                </div>
                <div className="info">
                  <span className="tit">수업변경 요청 횟수</span>
                  <span className="cont">0회</span>
                </div>
              </div>
            </div>
            <div className="com_board_box">
              <table className="com_board_list type_row">
                <colgroup>
                  <col width="25%" />
                  <col />
                </colgroup>
                <tbody>
                  <tr>
                    <th>최근 수능등급</th>
                    <td className="td_left">
                      <select className="select">
                        <option value="1등급">1등급</option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <th>목표 수능등급</th>
                    <td className="td_left">
                      <select className="select">
                        <option value="1등급">1등급</option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <th>최근 내신등급</th>
                    <td className="td_left">
                      <select className="select">
                        <option value="1등급">1등급</option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <th>목표 내신등급</th>
                    <td className="td_left">
                      <select className="select">
                        <option value="1등급">1등급</option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <th>평가기간</th>
                    <td className="td_left">
                      <div className="date_wrap">
                        <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                        <span className="divider"> ~ </span>
                        <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>진행 수업수</th>
                    <td className="td_left">
                      <input type="text" className="input" defaultValue={`8회`} />
                    </td>
                  </tr>
                  <tr>
                    <th>과제물 평가</th>
                    <td className="td_left">
                      <div className="com_input_wrap flex_row">
                        <div className="check">
                          <input type="radio" name="rdo" id="rdo_01" className="com_chk circle" />
                          <label htmlFor="rdo_01">매우좋음</label>
                          <input type="radio" name="rdo" id="rdo_02" className="com_chk circle" />
                          <label htmlFor="rdo_02">좋음</label>
                          <input type="radio" name="rdo" id="rdo_03" className="com_chk circle" />
                          <label htmlFor="rdo_03">보통</label>
                          <input type="radio" name="rdo" id="rdo_04" className="com_chk circle" />
                          <label htmlFor="rdo_04">나쁨</label>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>수업태도</th>
                    <td className="td_left">
                      <div className="com_input_wrap flex_row">
                        <div className="check">
                          <input type="radio" name="rdo" id="rdo_01" className="com_chk circle" />
                          <label htmlFor="rdo_01">매우좋음</label>
                          <input type="radio" name="rdo" id="rdo_02" className="com_chk circle" />
                          <label htmlFor="rdo_02">좋음</label>
                          <input type="radio" name="rdo" id="rdo_03" className="com_chk circle" />
                          <label htmlFor="rdo_03">보통</label>
                          <input type="radio" name="rdo" id="rdo_04" className="com_chk circle" />
                          <label htmlFor="rdo_04">나쁨</label>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th rowSpan={2}>수업성취도</th>
                    <td className="td_left">
                      <div className="com_input_wrap flex_row">
                        <select className="select">
                          <option value="과목">과목</option>
                        </select>
                        <input type="text" className="input" defaultValue={`진도 100`} />
                        <input type="text" className="input" defaultValue={`성취도 80`} />
                        <button className="btn_minus_gray" />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="td_left border_left">
                      <div className="com_input_wrap flex_row">
                        <select className="select">
                          <option value="과목">과목</option>
                        </select>
                        <input type="text" className="input" defaultValue={`진도 100`} />
                        <input type="text" className="input" defaultValue={`성취도 80`} />
                        <button className="btn_add_gray" />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>지급 교재</th>
                    <td className="td_left">
                      [고3] 기출리허설 생활과윤리 (2024학년도) <br />
                      [고3] 기출리허설 생활과윤리 (2024학년도)
                      <br />
                      [고3] 기출리허설 생활과윤리 (2024학년도)
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
          <section className="content_box scroll">
            <div className="detail_tit dot">학습 계획표</div>
            <div className="com_board_box">
              <textarea name="" className="textarea" placeholder="20자 이상 필수입력" />
            </div>
            <div className="detail_tit dot">개선사항 (학생 진도 및 수업관련 나아진점)</div>
            <div className="com_board_box">
              <textarea name="" className="textarea" placeholder="20자 이상 필수입력" />
            </div>
            <div className="detail_tit dot">수업계획 (학생 취약점에 대한 해결방안 제시)</div>
            <div className="com_board_box">
              <textarea name="" className="textarea" placeholder="20자 이상 필수입력" />
            </div>
            <div className="detail_tit dot">모의고사 / 내신 등급</div>
            <div className="com_chart_wrap">
              <div className="chart_body">
                <div className="chart_name">
                  <div className="chart_item">
                    <span className="chart_name_label">모의고사 등급</span>
                    <div className="chart_slider chart_blue"></div>
                  </div>
                  <div className="chart_item">
                    <span className="chart_name_label">내신등급</span>
                    <div className="chart_slider chart_orange"></div>
                  </div>
                </div>
                <div className="chart_content">
                  <LineChart data={lineChartData} width={lineChartWidth} height={lineChartHeight} />
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">등록</button>
      </div>
    </Modal>
  );
}

export default PopEvaluationReport;
